<template>
  <div>
    <b-row class="steps-tunnel w-75 mt-3 mb-5">
      <!-- step1 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ $t("general.Civilité") }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 1 }"
          @click="changeStep(1)"
        >
          1
        </b-button>
      </b-col>
      <b-col class="step-line"></b-col>
      <!-- step2 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ $t("general.Adresse") }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 2 }"
          :disabled="!step1ok"
          @click="changeStep(2)"
        >
          2
        </b-button>
      </b-col>
      <b-col class="step-line"></b-col>
      <!-- step3 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ $t("general.Notification") }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 3 }"
          :disabled="!step2ok"
          @click="changeStep(3)"
        >
          3
        </b-button>
      </b-col>
    </b-row>
    <!-- .. -->
    <div class="contact-block">
      <appStep1
        v-if="currentStep == 1"
        ref="step-1"
        :contact="contact"
        @updateContact="updateContact"
      />
      <appStep2
        v-if="currentStep == 2"
        ref="step-2"
        :contact="contact"
        @updateContact="updateContact"
      />
      <appStep3
        v-if="currentStep == 3"
        ref="step-3"
        :contact="contact"
        @updateContact="updateContact"
      />

      <!-- cancel, create, update -->
      <b-row class="mt-5 mb-2 justify-content-end">
        <b-col v-if="contactRegistered" cols="auto">
          <b-button class="button btn-blue" @click="finish">
            <font-awesome-icon icon="arrow-right" class="mr-2" />
            <span>{{ $t("general.continue") }}</span>
          </b-button>
        </b-col>
        <b-col v-else cols="auto">
          <b-button class="button btn-danger mx-2" @click="close">
            <font-awesome-icon icon="times-circle" class="mr-2" />
            <span>{{ $t("general.cancel") }}</span>
          </b-button>
          <b-button :disabled="isLoadingSave" class="button btn-blue" @click="goToNextStep">
            <span v-if="currentStep === 3">
              <font-awesome-icon v-if="!isLoadingSave" icon="save" />
              <font-awesome-icon v-else icon="spinner" pulse />
              <span class="ml-2">{{ $t("general.enregistrer") }}</span>
            </span>
            <span v-else>
              <font-awesome-icon icon="arrow-right" class="mr-2" />
              <span>{{ $t("general.continue") }}</span>
            </span>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { validate } from "vee-validate";
import { mapState } from "vuex";
import mixins from "@/mixins/mixins";
import meetingDetailsMixin from "@/mixins/meeting-details";

import ContactMW from "@/middlewares/Contact";

import appStep1 from "./Step1";
import appStep2 from "./Step2";
import appStep3 from "./Step3";

export default {
  components: {
    appStep1,
    appStep2,
    appStep3,
  },
  mixins: [mixins, meetingDetailsMixin],
  props: {
    buildingId: {
      type: String,
      default: "",
    },
    isInMeetingStart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentStep: 1,
      step1ok: false,
      step2ok: false,
      step3ok: false,
      isLoadingSave: false,
      contact: {
        agency_id: Number(localStorage.getItem("agencyId")),
        building_id: this.buildingId,
        address: "",
        zipcode: "",
        city: "",
        country: "FR",
        complement: "",
        complement2: "",
        entity_type: 1,
        contact_type: 1,
        can_vote: 0, // ???
        gender: 1,
        firstname: "",
        lastname: "",
        email: "",
      },
      contactRegistered: false,
    };
  },
  mounted() {
    // NOTE: positioning doesn't work as expected in modal, without setTimeout
    var self = this;
    setTimeout(function () {
      self.setStepTextsStyles();
    }, 0);
  },
  methods: {
    updateContact(key, value) {
      this.contact[key] = value;
    },
    async validateStep() {
      var valid = true;
      if (this.currentStep == 1) {
        await this.$refs["step-1"].$refs["vee-contact-lastname"].validate().then(res => {
          if (!res.valid) {
            valid = false;
          }
        });
      } else if (this.currentStep == 3) {
        await this.$refs["step-3"].$refs["vee-contact-email"].validate().then(res => {
          if (!res.valid) {
            valid = false;
          }
        });
      }
      return valid;
    },
    async changeStep(stepNb) {
      if (!(await this.validateStep())) {
        return;
      }

      this.currentStep = stepNb;
    },
    async goToNextStep() {
      if (!(await this.validateStep())) {
        return;
      }

      if (this.currentStep == 1) this.step1ok = true;
      if (this.currentStep == 2) this.step2ok = true;
      if (this.currentStep == 3 && !this.step3ok) {
        this.REGISTER_CONTACT();
        return;
      }

      this.currentStep++;
    },
    close() {
      this.$emit("closeModal");
    },
    REGISTER_CONTACT() {
      this.isLoadingSave = true;
      ContactMW.REGISTER(this.contact)
        .then(res => {
          this.contact.user_id = res.userId;
          this.contact.username = res.username;
          this.contact.password = res.password;

          this.CREATE_CONTACT();
        })
        .catch(() => {
          this.isLoadingSave = false;
        });
    },
    UPSERT_CONTACT() {
      ContactMW.UPSERT_CONTACT_PROCESS(this.contact)
        .then(contact => {
          this.contact.id = contact.id;
          this.isLoadingSave = false;
          this.step3ok = true;
          this.goToNextStep();
        })
        .catch(() => {
          this.isLoadingSave = false;
        });
    },
    CREATE_CONTACT() {
      ContactMW.POST(this.contact)
        .then(contact => {
          this.contact = contact;
          this.isLoadingSave = false;
          this.step3ok = true;
          this.setContactsData(this.buildingId);
          this.contactRegistered = true;
          if (this.isInMeetingStart) {
            this.setFreezedMeetingDetailsInMeeting(true);
          }
        })
        .catch(() => {
          this.isLoadingSave = false;
        });
    },
    finish() {
      this.$emit("setContact", this.contact);
    },
  },
};
</script>
